const IndustryCards = ({ industryCardData }) => {
  const {
    industryCardTitle,
    industryCardContent,
    industryCardImg,
    industryCardLink,
  } = industryCardData;

  return (
    <div className="landing__industry-card">
      <div className="landing__industry-card-left">
        <h6>{industryCardTitle}</h6>
        <p>{industryCardContent}</p>
      </div>
      <div className="landing__industry-card-right">
        <div className="industry-card-img-wrap">
          <img
            src={require(`../../image/newLanding/${industryCardImg}`)}
            alt="World's No.1 Blockchain Development Company"
            loading="lazy"
          />
        </div>
        <a href={industryCardLink} className="industry-card-link">
          <span>
            <i className="bi bi-arrow-up-right"></i>
          </span>
        </a>
      </div>
    </div>
  );
};

export default IndustryCards;
